import { Component, OnDestroy, OnInit } from '@angular/core';
import { QuoteOrderService } from '../../../services/quote-order/quote-order.service';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
import { MasterConstants } from '../../../common/constants/master-constants';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { Subscription } from 'rxjs';
import { CppService } from '../../../services/cpp/cpp.service';
import { CommonService } from './../../../services/common/common.service';
import { BroadcastService } from '../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../services/infrastructure/config.service';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ConfirmDialogComponent } from '../../../common/components/confirm-dialog/confirm-dialog.component';
import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { LolLoggerService } from './../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-create-quote-order',
  templateUrl: './create-quote-order.component.html',
  styleUrls: ['./create-quote-order.component.scss']
})
export class CreateQuoteOrderComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();

  quoteId: number;
  headerCompany = MasterConstants.US_COMPANYCODE;
  quoteIdSub: Subscription;
  quoteHeaderInfo: any;
  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  nextErrorId = 0;

  // Drop Down Lists Data
  shipToFacilityList: any[];
  soldToFacility: any[];
  deliverToList: any[];
  purchaseOrderError: string;
  // Header selected values
  shipToAccount: number;
  shipToAccountName: number;
  deliverToAccount: number;
  soldToAccount: number;
  instructionType: string;
  specialInstructionText: string;
  purchaseOrder: string;

  quoteProductItemsDataSource: any;
  quoteProductItemsAll: any;
  cppOriginalProductItemsDataSource: any;
  isTextBoxEmpty = true;
  previousSelectedValue: string;
  searchValue = '';
  partialSearchValue = '';
  itemNoList: any = [];
  isEvolveAccountRestriction = false;
  displayedColumns: string[] = ['product', 'viewDetail', 'totalQuoteQty', 'remainingQty', 'quantity', 'orderUOM', 'packageSize', 'deliveryDate'];
  instructionTypeList: Object;
  allChecked = false;
  isCustomerPickup = false;
  isSaveOrderDraftEnable = false;
  isPlaceOrderEnable = false;
  isAddProductEnable = false;
  filterArray = [];
  showTabs = false;
  tabNode: string;
  editToolKit = false;
  isShowOpenOnly = false;
  preparedEmailId = '';
  shipToDataLoading: any;
  deliverToDataLoading: any;
  soldToDataLoading: any;
  deliverToAnotherLocation = false;
  disablecheckbox: any;
  selectedFilter: any;
  selectedCount = 0;
  isSearchClicked: any;
  isReleased: any;
  index: any;
  enable: any;
  webOrderNumber = 0;
  cppOrderId = 0;
  isEditMode = false;
  dataChangeSubscription: any;
  hasChangeAdded = false;
  dateFilter: any;
  sub: Subscription;
  filteredDataCount = 0;
  qtyCount = 0;
  totalPrice = 0;
  isNotValid = false;
  accountEmail: string;
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  individualEmailPattern: any = MasterConstants.INDIVIDUAL_EMAIL_PATTERN;
  readOnlyAccess = false;
  date = new Date();
  maxDate = new Date(this.date.setMonth(this.date.getMonth() + 6));
  plAccess = false;
  isSubscriptionAccess = true;

  constructor(private router: Router,
    private localStorageService: LocalStorageService,
    private broadcastService: BroadcastService,
    private matDialog: MatDialog,
    private configService: ConfigService,
    private cppService: CppService,
    private toastrService: ToastrService,
    private loaderService: LoaderService,
    private quoteService: QuoteOrderService,
    private commonService: CommonService) { }

  ngOnInit() {

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isSubscriptionAccess = false;
          this.accountEmail = isActiveUser.emailId;;
        } else {
          this.isSubscriptionAccess = true;
        }
        // this.accountEmail = data.resultData[0].emailId;

        this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_ORDER);
        this.plAccess = this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST);
      }
    }

    this.subscription.push(this.quoteService.quoteId.subscribe(x => {
      if (x && x > 0) {
        this.quoteId = x;
        this.loadMasterData();
      }
    }));

    this.quoteProductItemsDataSource = new MatTableDataSource([]);
  }

  // Load master data
  loadMasterData() {
    this.loaderService.setLoaderStatus(true);

    // get Cpp Ship To Facility List
    this.subscription.push(this.cppService.getShipToFacilityList().subscribe(result => {
      this.shipToFacilityList = result;
      this.getOrderProduct();
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // Get Order Details when opened in Edit/View Mode
  getOrderProduct() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.quoteService.getQuoteOrderProduct(this.quoteId).subscribe((result: any) => {
      if (result && result.length > 0) {
        this.quoteHeaderInfo = result[0];

        this.preparedEmailId = '';
        if (result[0].preparedUserEmail) {
          this.preparedEmailId = result[0].preparedUserEmail.toLowerCase();
          this.accountEmail = this.isSubscriptionAccess ? '' : (this.accountEmail == '' ? this.preparedEmailId : (this.accountEmail + ';' + this.preparedEmailId));
        }

        // check for create/edit order
        this.subscription.push(this.quoteService.cppOrderId.subscribe(id => {
          if (id && id > 0) {
            this.cppOrderId = id;
            // call edit order api to fetch record
            this.getOrderDetails(result);
          }
          else {
            const shiptoList = this.shipToFacilityList.filter(x => x.parentNumber == this.quoteHeaderInfo.accountNumber);
            if (shiptoList && shiptoList.length == 0) {
              this.shipToFacilityList = this.shipToFacilityList.filter(x => x.accountNumber == this.quoteHeaderInfo.accountNumber);
            }
            else {
              this.shipToFacilityList = shiptoList;
            }

            result.map((x, rowid) => {
              x.rowId = x.quoteItemId;
              x.lineErrors = { 'rowId': rowid, 'errors': [] };
              x.fixedRemainingQty = x.remainingQty;
              return x;
            });
            this.quoteProductItemsDataSource.data = result;
            this.quoteProductItemsAll = JSON.parse(JSON.stringify(result));
          }
        }));
      }

      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // Get Order Details when opened in Edit/View Mode
  getOrderDetails(productList) {
    this.isEditMode = true;
    let deliverToAccount: number;
    let soldToAccount: number;
    // this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.cppService.getCppEditOrderDetail(this.cppOrderId).subscribe((result: any) => {
      this.webOrderNumber = result.webOrderNumber;
      this.shipToAccount = result.shipToAccountId;
      this.shipToAccountName = result.shipToAccountName;
      deliverToAccount = result.deliverToAccountId;
      soldToAccount = result.soldToAccountId;
      this.purchaseOrder = result.purchaseOrder;
      // this.accountEmail = result.emailAddress;
      this.specialInstructionText = result.specialInstruction == null ? '' : result.specialInstruction;
      this.instructionType = result.instructionType;
      this.isCustomerPickup = result.customerPickUp;
      // this.formatEditOrderData(result.productList);

      this.accountEmail = this.isSubscriptionAccess ? result.emailAddress : result.emailAddress + ';' + this.preparedEmailId;

      if (productList) {
        productList.map((x, rowid) => {
          const item = result.productList.filter(f => f.quoteItemId == x.quoteItemId);
          const quantity = item && item.length > 0 && item[0].orderQty ? item[0].orderQty : 0;
          x.rowId = x.quoteItemId;
          x.lineErrors = { 'rowId': rowid, 'errors': [] };
          x.quantity = quantity;
          x.fixedRemainingQty = x.remainingQty + quantity;
          return x;
        });

        this.quoteProductItemsDataSource.data = productList;
        this.quoteProductItemsAll = JSON.parse(JSON.stringify(productList));
      }

      this.subscription.push(this.cppService.getDeliverToFacilityList(result.shipToAccountId, result.parentAccountId).subscribe((result: any[]) => {
        this.deliverToList = result;
        this.deliverToAccount = deliverToAccount;
        this.deliverToAnotherLocation = deliverToAccount ? true : false;
        this.loaderService.setLoaderStatus(false);
      }, error => LolLoggerService.info(error)// this.loaderService.setLoaderStatus(false)
      ));

      this.subscription.push(this.cppService.getSoldToFacility(result.shipToAccountId).subscribe((result: any[]) => {
        this.soldToFacility = [result];
        this.soldToAccount = soldToAccount;
        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false)));

      this.enableDisableSaveDraft();
      this.isSaveOrderDraftEnable = false;
    }, error => LolLoggerService.info(error)
    ));
  }

  getShipTo(event) {
    if (event) {
      // Check for existing Draft Order
      this.subscription.push(this.quoteService.checkQuoteExistingDraftOrder(this.shipToAccount, this.quoteId).subscribe((result: any) => {
        if (result) {
          // Added Popup
          const title = 'Confirmation';
          const message = 'There is an existing Draft order for the selected account. Do you want to continue with that?';
          const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
            disableClose: true,
            width: '350px',
            data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
          });

          this.subscription.push(dialogRef.afterClosed().subscribe(yes => {
            if (yes == true) {// User selected Yes
              this.quoteService.setCppOrderId(+parseInt(result));
            }
          }));
        }
      }));

      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.cppService.getDeliverToFacilityList(event.accountNumber, event.parentNumber).subscribe((result: any[]) => {
        this.deliverToList = result;
        this.enableDisableSaveDraft();
        this.loaderService.setLoaderStatus(false);
      }
        , error => {
          this.loaderService.setLoaderStatus(false);
          this.enableDisableSaveDraft();
        }
      ));

      this.subscription.push(this.cppService.getSoldToFacility(event.accountNumber).subscribe((result: any[]) => {
        this.soldToFacility = [result];
        this.soldToAccount = this.soldToFacility[0].accountNumber;
        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false)));

      this.shipToAccountName = event.accountName;
    } else {
      this.deliverToList = null;
      this.deliverToAccount = null;
      this.soldToFacility = null;
      this.soldToAccount = null;
      this.enableDisableSaveDraft();
    }
  }

  getDeliverTo($event) {
    if ($event && this.isEditMode) {
      this.isAddProductEnable = true;   // Enable Add Product Button
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppDeliverToValue: true });
    }
    this.enableDisableSaveDraft();
  }

  UpdateDeliverToSelection(isDeliverToOptionChecked) {
    if (!isDeliverToOptionChecked) {
      this.deliverToAccount = null;
    }
  }

  hasHeaderInfoChanged(fieldName) {
    if (fieldName && this.shipToAccount && this.isEditMode) {
      switch (fieldName) {
        case 'PO':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppPOValue: true });
          break;
        case 'Special Instructions':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppSplInsValue: true });
          break;
        case 'Instruction Type':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppInsTypeValue: true });
          break;
        case 'Customer Pickup':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppCustPickupValue: true });
          break;
        case 'Email Address':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cppEmailAddressValue: true });
          break;
      }
      this.enableDisableSaveDraft();
    }
  }

  // Validate the email address entered
  validateEmail() {
    this.isNotValid = this.commonService.validateEmail(this.accountEmail, true);
    if (this.isNotValid) {
      this.isSaveOrderDraftEnable = false;
    }
    else {
      this.enableDisableSaveDraft();
    }
  }

  showProductDetails(item) {
    item.isProductDetailDisplayed = !item.isProductDetailDisplayed;
  }

  // unit change and validation
  quoteUnitChange(action: string, productItem: any) {
    productItem.quantity = this.isNumber(productItem.quantity) == true ? productItem.quantity : 0;

    if (action == 'decrease') {
      const decValue = +productItem.quantity - 1;
      if (decValue >= 0) {
        productItem.quantity = decValue;
        productItem.remainingQty = +productItem.remainingQty + 1;
      }
    }
    else {
      if (productItem.remainingQty > 0) {
        productItem.quantity = +productItem.quantity + 1;
        productItem.remainingQty = +productItem.remainingQty - 1;
      }
    }

    if (productItem.lineErrors && productItem.lineErrors.errors) {
      this.validateLineItem(productItem);
    }
  }

  // Qty change on text change
  quantityTextChange(productItem) {
    // get old data
    if (productItem.lineErrors && productItem.lineErrors.errors) {
      this.validateLineItem(productItem);
    }
  }

  // Line item validation
  validateLineItem(item: any) {
    if (item.quantity < 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'quantity');
      item.lineErrors.errors.push({ id: 'quantity', error: 'Quantity should not be negative' });
    }
    else if (item.quantity > item.fixedRemainingQty) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'quantity');
      item.lineErrors.errors.push({ id: 'quantity', error: 'The item quantity exceeds the remaining quantity available. Reduce the item quantity to continue.' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'quantity');
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
    }
    item.remainingQty = +item.fixedRemainingQty - +item.quantity;

    this.enableDisableSaveDraft();
    return item;
  }

  enableDisableSaveDraft() {
    if (this.quoteProductItemsDataSource.data && this.quoteProductItemsDataSource.data.length > 0
      && this.quoteProductItemsDataSource.data.some(x => x.quantity > 0)
      && this.shipToAccount && this.shipToAccount > 0) {
      this.isSaveOrderDraftEnable = true;
    }
    else {
      this.isSaveOrderDraftEnable = false;
    }
  }

  // Hide & show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.rowId == this.nextErrorId) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = this.index + 1;
      $('#cppOrderView').scrollTop = 0;
      if ($('#error_' + this.nextErrorId.toString()).offset()) {
        const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
        $('#cppOrderView').animate({ scrollTop: nextOffset }, 1000);
      }
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].rowId;
      this.currentErrorRow = 1;
      $('#cppOrderView').scrollTop = 0;
      $('#cppOrderView').animate({ scrollTop: 0 }, 1000);
    }
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    if (element && element != null && this.quoteProductItemsAll.length > 0 && this.quoteProductItemsDataSource.data.length > 0) {
      if (element && element != null && isSingleLine) {
        // get old data
        const oldLineValue = this.quoteProductItemsAll.filter(x => x.rowId == element.rowId)[0];

        // get current object index
        const currentLineIndex = this.quoteProductItemsDataSource.data.findIndex(x => x.rowId == element.rowId);

        // replace current with old object if exist
        if (currentLineIndex != -1) {
          this.quoteProductItemsDataSource.data[currentLineIndex] = JSON.parse(JSON.stringify(oldLineValue));
          this.quoteProductItemsDataSource.data = this.quoteProductItemsDataSource.data;

          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != currentLineIndex);

          // to hide one error after revert changes
          this.showHideLineError(oldLineValue.rowId);
          this.getCommonErrors(this.errorMsgs);
        }
      }
      else {
        // replace whole object
        this.quoteProductItemsDataSource.data = JSON.parse(JSON.stringify(this.quoteProductItemsAll));
        // To hide common error msg
        this.errorMsgs = new Array();
      }
    }
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true });
  }

  // Revert all changes
  revertAllChanges() {
    this.revertToPreviousError([], false);
    this.hideCommonError();
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock = false;
  }

  // Hide and show error line error
  showHideLineError(errorId: number) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString());
      if (errorDiv) {
        errorDiv.hide();
      }
    }
    else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach(x => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  saveDraft() {
    $('#cppOrderView').animate({ scrollTop: 0 }, 'slow');
    const saveObj: any = {};
    saveObj.quoteId = this.quoteId;
    saveObj.cppOrderId = this.cppOrderId;
    saveObj.companyCode = this.headerCompany;
    saveObj.shipToAccountId = this.shipToAccount;
    saveObj.deliverToId = this.deliverToAccount;
    saveObj.soldToId = this.soldToAccount;
    saveObj.purchaseOrderNumber = this.purchaseOrder;
    if ((this.specialInstructionText && (this.specialInstructionText != ''))) {
      saveObj.instructionType = 41;
    }

    saveObj.headerText = this.specialInstructionText;
    saveObj.emailAddress = this.accountEmail;
    saveObj.customerPickUp = this.isCustomerPickup;
    saveObj.quoteProductList = JSON.parse(JSON.stringify(this.quoteProductItemsDataSource.data.filter(x => x.quantity > 0)));

    saveObj.quoteProductList.forEach(x => {
      x.modifiedOrderedQuantity = x.orderConvFactor * x.quantity;
      x.pricingQuantity = x.pricingUnitConvFactor * x.quantity;
    });

    if (this.validateOrder()) {
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.quoteService.saveQuoteOrderDraft(saveObj).subscribe((result: any) => {
        if (result) {
          if (result.errors.length > 0) {
            this.loaderService.setLoaderStatus(false);
            result.errors.forEach(x => {
              this.toastrService.error(x);
              return false;
            });
          }
          else {
            const successMsg = (this.isEditMode) ? 'Order #' + result.webOrderNumber + ' updated successfully.' : 'CPP Order #' + result.webOrderNumber + ' saved successfully.';
            this.toastrService.success(successMsg);
            this.router.navigate(['/cpp/landing-data']);
            this.commonService.currentTabIndex.next(2);
            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
            this.loaderService.setLoaderStatus(false);
          }
        }
      }, (error) => {
        this.loaderService.setLoaderStatus(false);
        this.toastrService.error('Order not saved in the system.');
        LolLoggerService.error(error);
      }));
    }
  }

  // validation on Save Draft
  validateOrder() {
    let isValidated = true;
    if (this.quoteProductItemsDataSource.data && this.quoteProductItemsDataSource.data.length > 0) {
      isValidated = true;
      this.quoteProductItemsDataSource.data.forEach(x => {
        x = this.validateLineItem(x);
        if (x.lineErrors.errors.length > 0) {
          this.errorMsgs.push(x.lineErrors);
          this.getCommonErrors(this.errorMsgs);
          isValidated = false;
        }
      });
    }
    return isValidated;
  }

  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  showOpenOnly() {
    this.quoteProductItemsDataSource.data = this.quoteProductItemsAll.filter(x => (this.isShowOpenOnly && x.fixedRemainingQty > 0) || !this.isShowOpenOnly);
  }

  // On page destroy
  ngOnDestroy() {
    this.quoteService.setQuoteId(0);
    this.quoteService.setCppOrderId(0);
    this.quoteIdSub.unsubscribe();
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  redirectToLanding() {
    this.router.navigate(['/cpp/landing-data']);
    this.commonService.currentTabIndex.next(2);
  }

  // Only AlphaNumeric
  keyPressAlphaNumeric(event) {
    const inp = String.fromCharCode(event.keyCode);

    if (/[a-zA-Z0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  isNumber(n) {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
  }
}
